import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { ChevronDown, ChevronRight, MessageSquare } from 'lucide-react';
import api from '../services/api';
import { FEEDBACK_STATUS_LABELS } from '../types/feedback.types';
import type { FeedbackItemBase } from '../types/feedback.types';

const FeedbackHistory: React.FC = () => {
    const [expandedId, setExpandedId] = useState<number | null>(null);

    const { data, isLoading, isError } = useQuery(
        ['my-feedback'],
        () => api.feedback.getFeedbackList({ limit: 50 }),
        { staleTime: 30000 }
    );

    const feedbackList: FeedbackItemBase[] = data?.feedback || [];

    if (isLoading) {
        return <div className="feedback-loading">Loading your feedback...</div>;
    }

    if (isError) {
        return (
            <div className="feedback-history-empty">
                <MessageSquare size={40} />
                <p>Could not load your feedback. Please try again later.</p>
            </div>
        );
    }

    if (feedbackList.length === 0) {
        return (
            <div className="feedback-history-empty">
                <MessageSquare size={40} />
                <p>No feedback submitted yet.</p>
            </div>
        );
    }

    return (
        <div className="feedback-history-list">
            {feedbackList.map((item) => (
                <div key={item.id} className="feedback-history-item">
                    <button
                        type="button"
                        className="feedback-history-header"
                        onClick={() => setExpandedId(expandedId === item.id ? null : item.id)}
                    >
                        <div className="feedback-history-title">
                            {expandedId === item.id ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
                            <span className={`feedback-type-badge ${item.type}`}>{item.type}</span>
                            {item.title}
                        </div>
                        <div className="feedback-history-meta">
                            <span className={`feedback-status-badge ${item.status}`}>
                                {FEEDBACK_STATUS_LABELS[item.status] || item.status}
                            </span>
                        </div>
                    </button>
                    {expandedId === item.id && (
                        <div className="feedback-history-detail">
                            <p>{item.description}</p>
                            <p style={{ fontSize: '12px', color: '#9ca3af', marginTop: '8px' }}>
                                Submitted {new Date(item.created_at).toLocaleDateString()}
                            </p>
                            {item.admin_notes && (
                                <div className="admin-response">
                                    <strong>Admin Response:</strong>
                                    <p style={{ margin: '4px 0 0' }}>{item.admin_notes}</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default FeedbackHistory;
